export default "__VITE_ASSET__YPwwXoQW__"